import state from './moduleProductExtraState.js'
import mutations from './moduleProductExtraMutations.js'
import actions from './moduleProductExtraActions.js'
import getters from './moduleProductExtraGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

